/* eslint-disable camelcase */
import dayjs from "@shared/dayjs";

const createPerson = ({ first_name, last_name, avatar_url, uuid, id }) => ({
  fullName: `${first_name} ${last_name}`,
  avatar: avatar_url,
  uuid,
  id,
});

const createContingent = (contingencyRule) => !!Object.keys(contingencyRule).length && contingencyRule;

export const createDate = (date) => {
  if (!date) return null;
  const parsed = dayjs(date, "YYYY-MM-DD");

  return parsed.isValid() ? parsed.format("MM/DD/YY") : null;
};

export const createTask = (task) => ({
  ...task,
  assigned_person: task.assigned_person && createPerson(task.assigned_person),
  assigned_to_user_id: task.assigned_person?.uuid,
  completed_by: task.completed_by && createPerson(task.completed_by),
  recurring_frequency: task.recurring ? task.recurring_frequency : null,
  recurring_day_of_week: task.recurring ? task.recurring_day_of_week : null,
  recurring_every_so_many_days: task.recurring ? task.recurring_every_so_many_days : null,
  completed_at: createDate(task.completed_at),
  contingent: task.contingent && createContingent(task.contingency_rule),
});

export const adaptPostDueOn = (date) =>
  date ? dayjs(date, "MM/DD/YYYY").format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");

export const adaptRecurringDays = (payload) =>
  payload.recurring?.frequency?.value === "number"
    ? payload.recurring?.recurring_every_so_many_days * 1
    : null;

export const adaptRecurringDayOfWeek = (payload) =>
  payload.recurring?.frequency?.value === "weekly" ? payload.recurring?.recurring_day_of_week.value : null;

export const adaptContingentRule = (payload) =>
  payload.contingent
    ? {
        days: payload.contingent?.numOfDays * 1,
        position: payload.contingent?.next,
        event: payload.contingent?.event?.value,
      }
    : null;

export const createFilters = (fl, tasks) => {
  const filters = JSON.parse(JSON.stringify(fl));

  tasks.forEach(
    ({ assigned_plan, assigned_person, completed_at, contingent, contingentEventId, due_on }, idx) => {
      if (completed_at) {
        filters.primaryFilters.byName.completed_at.count += 1;
        filters.primaryFilters.byName.completed_at.tasks.push(idx);
        return;
      }
      if (contingent && !due_on) {
        filters.primaryFilters.byName.upcoming.count += 1;
        filters.primaryFilters.byName.upcoming.tasks.push(idx);
        if (!filters.byContingentId[contingentEventId]) {
          filters.byContingentId[contingentEventId] = { tasks: [idx] };
        } else {
          filters.byContingentId[contingentEventId].tasks.push(idx);
        }

        return;
      }

      if (due_on && dayjs(due_on).isAfter(dayjs(), "day")) {
        filters.primaryFilters.byName.upcoming.count += 1;
        filters.primaryFilters.byName.upcoming.tasks.push(idx);
      }

      if (due_on && dayjs(due_on).isSame(dayjs(), "day")) {
        filters.primaryFilters.byName.due_today.count += 1;
        filters.primaryFilters.byName.due_today.tasks.push(idx);
      }

      if (due_on && dayjs(due_on).isBefore(dayjs(), "day")) {
        filters.primaryFilters.byName.overdue.count += 1;
        filters.primaryFilters.byName.overdue.tasks.push(idx);
      }

      if (!assigned_person && !assigned_plan) {
        filters.secondaryFilters.byUnAssigned.count += 1;
        filters.secondaryFilters.byUnAssigned.tasks.push(idx);
      }

      if (assigned_person) {
        if (assigned_person.id in filters.secondaryFilters.byTeamMember) {
          filters.secondaryFilters.byTeamMember[assigned_person.id].count += 1;
          filters.secondaryFilters.byTeamMember[assigned_person.id].tasks.push(idx);
        } else {
          filters.secondaryFilters.byTeamMember = {
            ...filters.secondaryFilters.byTeamMember,
            [assigned_person.id]: {
              count: 1,
              tasks: [idx],
              id: assigned_person.id,
              fullName: assigned_person.fullName,
              avatar: assigned_person.avatar,
            },
          };
        }
      }
    },
  );

  return filters;
};
